export default [
  {
    path: "/viewstock",
    name: "viewstock",
    component: () => import('../components/reports/viewstock.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/stockdetail",
    name: "stockdetail",
    component: () => import('../components/reports/stockdetail.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/outdetail",
    name: "outdetail",
    component: () => import('../components/reports/outdetail.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/indetail",
    name: "indetail",
    component: () => import('../components/reports/indetail.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/pddetail",
    name: "pddetail",
    component: () => import('../components/reports/pddetail.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/dbdetail",
    name: "dbdetail",
    component: () => import('../components/reports/dbdetail.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/incountgoods",
    name: "incountgoods",
    component: () => import('../components/reports/incount-goods.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/incountunit",
    name: "incountunit",
    component: () => import('../components/reports/incount-unit.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/incountemp",
    name: "incountemp",
    component: () => import('../components/reports/incount-emp.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/outcountgoods",
    name: "outcountgoods",
    component: () => import('../components/reports/outcount-goods.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/outcountunit",
    name: "outcountunit",
    component: () => import('../components/reports/outcount-unit.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/outcountemp",
    name: "outcountemp",
    component: () => import('../components/reports/outcount-emp.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/lr",
    name: "lr",
    component: () => import('../components/reports/goods-lr.vue'),
    meta: { keepAlive: true }
  },
]



// WEBPACK FOOTER //
// ./src/router/reports-router.js